import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Self-hosted, so the app makes no request to a font CDN. Only the weights the
// design actually uses: 500 and 600 are what a heading is, now that there is
// no display face.
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/600.css'

// Tailwind, the design tokens and the shadcn layer, all from one entry.
import './index.css'

import { App } from './App.tsx'

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('#root element missing from index.html')
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
)
